// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function partner_subscription_encode(v) {
  return Js_dict.fromArray([
              [
                "payment_reference_number",
                Decco.optionToJson(Decco.stringToJson, v.payment_reference_number)
              ],
              [
                "expiry_reason",
                Decco.optionToJson(Decco.stringToJson, v.expiry_reason)
              ],
              [
                "expiry_date",
                Decco.optionToJson(Decco.stringToJson, v.expiry_date)
              ],
              [
                "end_date",
                Decco.stringToJson(v.end_date)
              ],
              [
                "scheme_name",
                Decco.stringToJson(v.scheme_name)
              ],
              [
                "start_date",
                Decco.stringToJson(v.start_date)
              ],
              [
                "status",
                Decco.stringToJson(v.status)
              ],
              [
                "subscription_price",
                Decco.optionToJson(Decco.intToJson, v.subscription_price)
              ]
            ]);
}

function partner_subscription_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var payment_reference_number = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "payment_reference_number"), null));
  if (payment_reference_number.TAG === /* Ok */0) {
    var expiry_reason = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expiry_reason"), null));
    if (expiry_reason.TAG === /* Ok */0) {
      var expiry_date = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expiry_date"), null));
      if (expiry_date.TAG === /* Ok */0) {
        var end_date = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_date"), null));
        if (end_date.TAG === /* Ok */0) {
          var scheme_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scheme_name"), null));
          if (scheme_name.TAG === /* Ok */0) {
            var start_date = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_date"), null));
            if (start_date.TAG === /* Ok */0) {
              var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
              if (status.TAG === /* Ok */0) {
                var subscription_price = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subscription_price"), null));
                if (subscription_price.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            payment_reference_number: payment_reference_number._0,
                            expiry_reason: expiry_reason._0,
                            expiry_date: expiry_date._0,
                            end_date: end_date._0,
                            scheme_name: scheme_name._0,
                            start_date: start_date._0,
                            status: status._0,
                            subscription_price: subscription_price._0
                          }
                        };
                }
                var e = subscription_price._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".subscription_price" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = status._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".status" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = start_date._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".start_date" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = scheme_name._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".scheme_name" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = end_date._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".end_date" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = expiry_date._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".expiry_date" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = expiry_reason._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".expiry_reason" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = payment_reference_number._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".payment_reference_number" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "subscriptions",
                Decco.listToJson(partner_subscription_encode, v.subscriptions)
              ],
              [
                "next_offset_ts",
                Decco.intToJson(v.next_offset_ts)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var subscriptions = Decco.listFromJson(partner_subscription_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subscriptions"), null));
  if (subscriptions.TAG === /* Ok */0) {
    var next_offset_ts = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "next_offset_ts"), null));
    if (next_offset_ts.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                subscriptions: subscriptions._0,
                next_offset_ts: next_offset_ts._0
              }
            };
    }
    var e = next_offset_ts._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".next_offset_ts" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = subscriptions._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".subscriptions" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  partner_subscription_encode ,
  partner_subscription_decode ,
  t_encode ,
  t_decode ,
  
}
/* No side effect */
